module.exports = __webpack_public_path__ + "img/dialogHeader.c341f868.png";